function cartObjectify(id, qty, props) {
  return { id: id, quantity: qty, properties: props }
}

function getSelectedAddons() {
  const checkBoxes = document.querySelectorAll('.gdc-addons-list__item-checkbox')

  return [...checkBoxes].filter((cb) => cb.checked)
}

function addonsArray(checkBoxes) {
  return checkBoxes.map((item) => {
    let productHandle = item.dataset.productHandle
    let id = item.dataset.variantId
    let qtyToGet = "qty-for-" + id
    let quantity = document.getElementById(qtyToGet).value
    let properties = { For: `${productHandle}` }

    return cartObjectify(id, quantity, properties)
  })
}

function clickThemeAddToCart() {
  const atcButton = document.querySelector('.product-form__cart-submit')
  setTimeout(() => {
    atcButton.click()
  }, 500)
}

function addNoteToPopup(num) {
  setTimeout(() => {
    const popupProduct = document.querySelector('.purchase-confirmation-popup__item')
    const message = `<div style="margin-top: 10px">+ plus ${num} addon${num > 1 ? 's' : ''}</div>`
    popupProduct && popupProduct.insertAdjacentHTML('beforeend', message)
  }, 2500)
}

function handleAddons(event) {
  event.preventDefault()
  const addons = addonsArray(getSelectedAddons())
  const addonsSelected = addons.length
  const formData = { items: addons }

  addToCart(formData)
  clickThemeAddToCart()
  if (addonsSelected > 0) {
    addNoteToPopup(addonsSelected)
  }
}

async function addToCart(formData) {
  const result = await fetch('/cart/add.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(formData),
  })
}

async function updateItem(data) {
  const result = await fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
}

async function getCart() {
  const result = await fetch('/cart.json')

  if (result.status === 200) {
    return result.json()
  }

  throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`)
}

function getCurrentURLPath() {
  return window.location.pathname
}

function cartAddons({ items }) {
  return items.filter((item) => item.product_type.toLowerCase().trim() === 'add on')
}

function cartProducts(cart) {
  return cart.items.filter((item) => item.product_type.toLowerCase().trim() !== 'add on')
}

function cartProductHandles(cart) {
  return cartProducts(cart).map((item) => item.handle)
}

function cartContainsAddons(cart) {
  const cartAddonsCount = cartAddons(cart).length

  return cartAddonsCount > 0
}

async function deleteCartItemsByKey(lineItemsArray) {
  // For delaying api calls in for loop Returns a Promise that resolves after "ms" Milliseconds
  const delay = (ms) => new Promise((res) => setTimeout(res, ms))

  for (var i = 0; i < lineItemsArray.length; i++) {
    console.log('deleting', lineItemsArray[i].key)
    updateItem({
      id: lineItemsArray[i].key,
      quantity: 0,
      properties: {},
    })
    await delay(200) // then the created Promise can be awaited
  }
}

async function checkForMatchingProducts(cart) {
  const strayAddonKeys = cartAddons(cart).filter((addon) => {
    let matchingAddon = addon.properties['For']
    let matchingProduct = cartProductHandles(cart).includes(matchingAddon)
    if (!matchingProduct) {
      return addon
    }
  })

  if (strayAddonKeys.length > 0) {
    await deleteCartItemsByKey(strayAddonKeys)
    location.reload()
  }
}

function isCartPage() {
  return getCurrentURLPath().includes('cart')
}

function removeUnmatchedAddonsFromCart() {
  setTimeout(() => {
    getCart().then((cart) => {
      cartContainsAddons(cart) && checkForMatchingProducts(cart)
    })
  }, 500)
}

function removeUnmatchedAddonsFromQuickCart() {
  if (quickCart()) {
  }
}

function setCartObservers() {
  // watches for change in small number in header cart icon (all pages)
  const targetNode = document.getElementById('gdc-js-cart-count')
  const config = { attributes: true, childList: true, subtree: true }

  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        console.log('A child node has been added or removed.')
      } else if (mutation.type === 'attributes') {
        console.log(`The ${mutation.attributeName} attribute was modified.`)
      }
    }

    removeUnmatchedAddonsFromCart()
  }

  if (targetNode) {
    const observer = new MutationObserver(callback)
    observer.observe(targetNode, config)
  }
}

window.addEventListener('DOMContentLoaded', setCartObservers)
